import manifest from 'pwa/manifest.json';

/**
 * Checks if the agent-interface is loaded on a mobile platform and if the
 * agent-interface is loaded as a Progressive Web App (PWA).
 */
export function isMobilePWA(): boolean {
  return /(Mobile)|(Android)/gi.test(navigator.userAgent) && isPWA();
}

/**
 * Media query to check if agent-interface is loaded as a Progressive Web App
 * (PWA).
 */
export const pwaMediaQuery = `(display-mode: ${manifest.display})`;

/** Checks if the agent-interface is loaded as a Progressive Web App (PWA). */
export function isPWA(): boolean {
  return window.matchMedia(pwaMediaQuery).matches;
}
